module.exports = __webpack_public_path__ + "media/assets/images/blog/tablet_doc-14501502bcb7d6f28634c0ebecec95d7.jpeg";